import React from 'react'

import Button from './Button'

import closeBtn from 'assets/images/close.svg'

export default class ModalAlert extends React.Component {
  render() {
    const { modalTitle = 'Ошибка', modalText, closeModal } = this.props

    return (
      <>
        <div className='modal-overlay'>
          <div className='modal modal--sm'>
            <div className='modal__header'>
              <p className='modal__title'>{modalTitle}</p>
              <Button
                className='button--icon'
                icon={true}
                iconPicture={closeBtn}
                action={closeModal}
              />
            </div>

            <div className='modal__content'>{modalText}</div>

            <div className='modal__bottom modal__bottom--center'>
              <Button
                title='Закрыть'
                className='btn--lg btn--primary'
                action={closeModal}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}
